module.exports = __webpack_public_path__ + "img/sf3.ad699471.png";